<template>
  <header-app></header-app>
  <router-view/>
  <footer-app></footer-app>
  <cookies-bar></cookies-bar>
</template>


<script>
import HeaderApp from "./components/HeaderApp.vue";
import FooterApp from "./components/FooterApp.vue";
import CookiesBar from "./components/CookiesBar.vue";

export default {
  name : "App",
  components : {
    HeaderApp,
    FooterApp,
    CookiesBar
  }
}
</script>

<style lang="scss">
@import "./scss/variables.scss";
@import url('https://fonts.googleapis.com/css2?family=Lekton:ital,wght@0,400;0,700;1,400&display=swap');
body, p, h1, h2, h3, h4, a {
  margin:0;
  padding:0;
  font-family: "Lekton", monospace;
}

p {
  color:$textColor;
  text-align: justify;
}

p .focus, h1, h2, h3, h4 {
  color:$mainColor;
}

h2 {
  font-size:30px;
  font-weight: 400;
  letter-spacing: 1px;
  line-height: 1em;
  margin-bottom: 20px;
  text-transform: uppercase;
}

h2 span {
  text-transform: none;
  // margin-left: 30px;
  //font-weight: 600;
}




.main {
  width: $box;
  max-width: 90%;
  margin:0 auto;
}

.mailto {
  color:$mainColor;
  text-decoration: none;
}

.mailto:hover {
  text-decoration: underline;
}


.copy {
  font-family: "Lekton", monospace;
  font-size:15px;
}
    
p.program-desc span {
  color:$mainColor;
}

.modal-container p i {
  font-size: 13px;
}

.modal-container a {
    text-decoration: none;
    color:$mainColor;
}

.modal-container a:hover {
    text-decoration: underline;
}

sup {
  font-size: 10px;
  vertical-align: super;
}

</style>
